'use client';

import { FC } from 'react';
import { TextField } from '@mui/material';
import { useRange } from '@/components/common/Range/useRange';
import { RangeRow } from '../styled';

interface RangeInputsProps {
  minLabel: string;
  maxLabel: string;
  value: number[];
  minValue: number;
  maxValue: number;
  onChange: (v: number[]) => void;
}

export const RangeInputs: FC<RangeInputsProps> = ({
  minLabel,
  maxLabel,
  value,
  minValue,
  maxValue,
  onChange,
}) => {
  const { inputValue, handleFocus, handleBlur, handleInputChange } = useRange(
    value,
    minValue,
    maxValue,
    onChange,
  );

  return (
    <RangeRow>
      <TextField
        size="small"
        label={minLabel}
        value={inputValue[0]}
        onChange={handleInputChange(0)}
        onFocus={handleFocus(0)}
        onBlur={handleBlur(0)}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        sx={{ flex: 1 }}
      />
      <TextField
        size="small"
        label={maxLabel}
        value={inputValue[1]}
        onChange={handleInputChange(1)}
        onFocus={handleFocus(1)}
        onBlur={handleBlur(1)}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        sx={{ flex: 1 }}
      />
    </RangeRow>
  );
};
